import { Loader2 } from 'lucide-react';

export function LoadingOverlay() {
  return (
    <div className="flex h-32 items-center justify-center">
      <div className="flex flex-col items-center gap-2 text-slate-500">
        <Loader2 className="h-8 w-8 animate-spin text-park-600" />
        <span className="text-sm">Loading challans...</span>
      </div>
    </div>
  );
}
